import { registerGroup, registerCircle, registerRect, registerText } from "@visactor/vrender-kits";

export function loadSwitchComponent() {
    registerGroup(), registerRect(), registerText(), registerCircle();
}
//# sourceMappingURL=register.js.map
